module.exports = __webpack_public_path__ + "media/images/icons/social/linkedin-9fb22d34f53525891a9a4063262a098f.svg";